export default function ContactSection() {
  return (
    <section id="contact" className="py-10 md:py-14 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6 p-6 md:p-8 rounded-2xl bg-background-100 border border-background-200/70">
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100 flex-shrink-0">
              <i className="ri-mail-send-line text-primary-500 text-xl"></i>
            </div>
            <div>
              <h3 className="text-base font-heading text-foreground-800">联系我们</h3>
              <p className="text-sm text-foreground-500 mt-0.5">
                投稿、合作、问题反馈 — 欢迎随时联系女神漫画网团队
              </p>
            </div>
          </div>
          <a
            href="mailto:contact@nvshenmanhua.com"
            className="inline-flex items-center gap-2 px-6 py-2.5 bg-primary-500 text-background-50 font-medium rounded-full hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer text-sm"
          >
            <i className="ri-chat-smile-2-line"></i>
            立即联系
          </a>
        </div>
      </div>
    </section>
  );
}